import {
    getSilentRefreshedToken,
    getRefreshedToken
} from "@components/SitecoreComponent/Users/access-token-for-fetcher";
import { fetcher, getApiUrl } from './fetcher-raw';

export type FetchConfig = {
    method?: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
    headers?: Record<string, string>;
    body?: string | FormData;
};

export async function fetchApi(
    path: string,
    options?: FetchConfig,
    skipAuth?: boolean,
): Promise<Response> {
    const token = skipAuth ? null : await getSilentRefreshedToken();

    const buildHeaders = (): Record<string, string> => {
        const headers: Record<string, string> = {};
        if (!(options?.body instanceof FormData)) {
            headers["Content-type"] = "application/json";
        }
        if (token) headers["Authorization"] = `Bearer ${token}`;
        return headers;
    };

    let response = await fetcher(getApiUrl() + path, {
        ...options,
        headers: { ...options?.headers, ...buildHeaders() },
    });

    if (response.status === 401) {
        const newToken = await getRefreshedToken();
        if (newToken) {
            response = await fetcher(getApiUrl() + path, {
                ...options,
                headers: {...options?.headers, ...buildHeaders()},
            });
        }
    }
    return response;
}

export type GraphQLError = {
    errors: Array<{
        message: string;
    }>;
};

export async function fetchApiGraphQL<T>(
    query: string,
    variables: Record<string, unknown>,
    skipAuth?: boolean,
) {
    const response = await fetchApi("/graphql", {
        method: "POST",
        body: JSON.stringify({
            query,
            variables,
        }),
    }, skipAuth);

    const resultObj: T | GraphQLError = await response.json();
    const errorObj = resultObj as GraphQLError;
    if (errorObj?.errors?.length) {
        throw errorObj;
    }

    const result = resultObj as T;
    return result;
}

export async function fetchApiJson<T>(
    path: string,
    method: FetchConfig["method"] = "GET",
    body?: object,
    skipAuth?: boolean,
): Promise<T> {
    const bodyJson = body ? JSON.stringify(body) : undefined;
    const response = await fetchApi(path, {
        method,
        body: bodyJson,
    }, skipAuth);
    const result = (await response.json()) as T;
    return result;
}

export default fetcher;
